/**
 * モーダルプラグイン modaalの設定
 * https://github.com/humaan/Modaal
 */

$(document).ready(function () {
	// 動画用スクリプト
	$('.modal_iframe').modaal({
		type: 'video'
	});

	$('.fugafuga').modaal({
		// オプション

		// モーダルが表示、非表示されるまでに秒数設定
		animation_speed: 300,
		// overlayの色の設定
		background: "#000",
		// overlayの透過量
		overlay_opacity: "0.8",
		// 開く前に発火
		before_open: function () {
			alert('Before open');
		},
		// 閉じた後に発火
		after_close: function () {
			alert('after close');
		}
	});

	//特定の要素を閉じるボタンに設定
	$('.piyopiyo').modaal('close');

});
